import React from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { useEffect } from "react";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import { CustomButton } from "../../../components/main_comps/custom_button";
import {
  storeAllAcls,
  storeResponseToLocalStorage,
} from "../../../../services/loginService";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { addToAclList } from "../../../../data/redux/slice/aclSlice";
import {
  CLIENT,
  RESELLER,
  STATUS_CODE_200,
  VAN_ACL,
} from "../../../../utility/constants/valueConstants";
import { authSliceReducerSlice } from "../../../../data/redux/slice/authSlice";
import ResizeListner from "../../../../utility/ResizeListner";
import {
  CollectBotBgLogo,
  NeokredNewLogo,
} from "../../../../utility/constants/assetsManager";
import {
  bgColor,
  colorWhite,
} from "../../../../utility/constants/colorManager";

function Verified2fa() {
  const navigate = useNavigate();
  const { height, width } = ResizeListner();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const location = useLocation();
  const responseData = location.state ? location.state.response : null;

  const [qrCodeImage, setQrCodeImage] = useState("");
  const [isSetupDone, setIsSetupDone] = useState(false);
  const [setupData, setSetupData] = useState(null);
  const [code, setCode] = useState("");
  const [step, setStep] = useState(0);
  const [verified, setVerified] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (code.length === 6) {
      setDisabled(false);
    } else setDisabled(true);
  }, [code]);

  useEffect(() => {
    setIsSetupDone(responseData.twoFactorSetup);

    setStep(responseData.twoFactorSetup ? 1 : 0);

    if (!responseData.twoFactorSetup) {
      setup2fa(responseData);
    }
  }, [responseData]);

  const setup2fa = (data) => {
    ApiRequestPost.setup2fa({
      userId: data?.userId,
    })
      .then((response) => {
        if (response.data.qrCode) {
          setQrCodeImage(`data:image/png;base64, ${response.data.qrCode}`);
          setSetupData(data);
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
       
      });
  };

  const showCodeInput = () => {
    setStep(1);
  };

  const verify = () => {
    setLoading(true);
    try {
      ApiRequestPost.verify2fa({
        userId: responseData?.userId,
        code,
      }).then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          // navigate("/dashboard");
          fecthDetails(response.data);
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
          setLoading(false);

    
        }
      });
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      setLoading(false);
    }
  };

  const fecthDetails = (data) => {
    ApiRequestPost.fetchUserDetails({
      role: data?.role,
      userId: data?.userId,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          storeResponseToLocalStorage({
            ...response.data,
            ...data,
            isVerified:
              data.role?.toUpperCase() === CLIENT
                ? response?.data?.isVerified
                : "",
          });

          dispatch(addToAclList(storeAllAcls(data?.aclList)));
          dispatch(authSliceReducerSlice(true));

          if (
            data?.aclList?.length === 1 &&
            data?.aclList[0]?.acl_value === VAN_ACL
          ) {
            navigate("/van/dashboard");
          } else {
            navigate("/dashboard");
          }
          enqueueSnackbar("Logged in successfully", {
            variant: "success",
          });
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      });
  };

  useEffect(() => {
    let url = window.location.href;

    if (url.includes("https://payinpayout.in")) {
      setVerified(NeokredNewLogo);
    } else {
      setVerified(CollectBotBgLogo);
    }
  }, []);

  // setup 2fa setup is false // verify
  return (
    <div
      style={{
        width,
        display: "flex",
        flexDirection: width > 650 ? "row" : "column",
        height: height,
      }}
    >
      <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: width > 650 ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: colorWhite,
        }}
      >
        <img
          src={verified}
          alt="logo"
          style={{
            width: width * 0.35,
            minWidth: 150,
            maxWidth: 400,
          }}
        />
      </div>
      <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: bgColor,
          flexDirection: "column",
          height,
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
          }}
        >
          <div>
            {step === 0 ? (
              <div className="form-qr">
                <h1>2FA Authentication</h1>
                <p
                  style={{
                    fontSize: 15,
                    color: "#2D3748",
                    margin: 0,
                    marginBottom: 20,
                    marginTop: 5,
                  }}
                  className="roboto"
                >
                  {/* {responseData} */}
                  Please scan the QR code to get 6-digit code
                </p>
                <div>
                  <img src={qrCodeImage} alt="QR Code" />
                </div>
                <CustomButton
                  title="Next"
                  styles={{
                    width: "100%",
                    borderRadius: "4px",
                    marginTop: 40,
                    height: "50px",
                  }}
                  textStyle={{
                    fontSize: 15,
                    fontWeight: 500,
                  }}
                  onClick={showCodeInput}
                />
              </div>
            ) : (
              <div>
                <div
                  style={{
                    width: width > 650 ? "45%" : "70%",
                    minWidth: width > 650 ? 300 : 250,
                  }}
                >
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: 27,
                      marginBottom: 30,
                      color: "#1A202C",
                      margin: 0,
                    }}
                    className="roboto"
                  >
                    Enter Verification Code
                  </p>
                  <p
                    style={{
                      fontSize: 15,
                      color: "#2D3748",
                      margin: 0,
                      marginBottom: 20,
                      marginTop: 5,
                    }}
                    className="roboto"
                  >
                    Please enter the 6-digit code from your authenticator app.
                  </p>

                  <CustomInput
                    type={"input"}
                    title="Code"
                    value={code}
                    placeholder="6-digit code"
                    onChange={(value) => setCode(value)}
                    inputStyles={{
                      width: "100%",
                      border: "1px solid #E8E8E8",
                      boxShadow: "none",
                      backgroundColor: "white",
                      height: "50px",
                    }}
                    inputcomponentStyles={{ letterSpacing: 2 }}
                    validator="otp"
                  />
                  <CustomButton
                    loading={loading}
                    title="Verify"
                    styles={{
                      width: "100%",
                      borderRadius: "4px",
                      marginTop: 40,
                      height: "50px",
                    }}
                    textStyle={{
                      fontSize: 15,
                      fontWeight: 500,
                      color: colorWhite,
                    }}
                    onClick={verify}
                    disabled={disabled}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Verified2fa;
